import type {
  PostKidsBoughtNewShoesRequest,
  PostKidsBoughtNewShoesResponse,
} from '~/api/aspida/@types';
import { sendRequest } from '~/api/sendRequest';

export const postKidsBoughtNewShoes = sendRequest<
  PostKidsBoughtNewShoesRequest,
  PostKidsBoughtNewShoesResponse
>({
  url: '/kids/bought_new_shoes',
  method: 'post',
});
